import type { BasePaginationDto } from '@@types/api.types';
import { Button } from '@components/ui/button';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@components/ui/select';
import React from 'react';

const PAGE_SIZE_OPTIONS = [25, 50, 100];

type AdminPaginationProps = {
  isFetching?: boolean;
  itemLabel: string;
  onLimitChange: (limit: number) => void;
  onNextPage: () => void;
  onPreviousPage: () => void;
  pagination: BasePaginationDto;
};

export const AdminPagination: React.FC<AdminPaginationProps> = (props) => {
  const { isFetching, itemLabel, onLimitChange, onNextPage, onPreviousPage, pagination } = props;

  const startItem = (pagination.page - 1) * pagination.limit + 1;
  const endItem = Math.min(pagination.page * pagination.limit, pagination.totalItems);

  return (
    <div className="flex flex-col gap-3 md:flex-row md:items-center md:justify-between">
      <div className="flex items-center gap-2 text-xs text-gray-500">
        <span>
          Showing {startItem} to {endItem} of {pagination.totalItems} {itemLabel}
        </span>
      </div>

      <div className="flex items-center gap-3">
        <Select
          onValueChange={(value) => onLimitChange(Number(value))}
          value={String(pagination.limit)}
        >
          <SelectTrigger className="w-[140px]">
            <SelectValue placeholder="Page size" />
          </SelectTrigger>
          <SelectContent>
            {PAGE_SIZE_OPTIONS.map((option) => (
              <SelectItem
                key={option}
                value={String(option)}
              >
                {option} per page
              </SelectItem>
            ))}
          </SelectContent>
        </Select>

        <div className="flex items-center gap-2">
          <Button
            disabled={isFetching || !pagination.hasPreviousPage}
            onClick={onPreviousPage}
            type="button"
            variant="outline"
          >
            Previous
          </Button>
          <Button
            disabled={isFetching || !pagination.hasNextPage}
            onClick={onNextPage}
            type="button"
          >
            Next
          </Button>
        </div>
      </div>
    </div>
  );
};
